export default "__VITE_ASSET__1qvadO8t__"